import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import { Link } from "react-router";
import Modal from "../components/modal.react";
import Table from "./table.react";
import InputWithError from "../components/inputWithError.react";
import Select from "react-select";

export default class MediaCategory extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadTemplates();
  }

  loadTemplates = () => {
    const {
      actions,
      templates: { templates: { meta: templatesMeta } },
      notificationSystem,
      users: { currentUser }
    } = this.props;

    let isAdmin = false;
    currentUser.get("groups").forEach(function(group) {
      if (group.name === "admin") {
        isAdmin = true;
      }
    });

    if (isAdmin) {
      actions.getTemplates(templatesMeta).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          if (payload.result.templates[0]) {
            actions.setFormField(
              "pageTranslations",
              "createPageTranslation",
              "templateUID",
              payload.result.templates[0]
            );
          }
        }
      });
    }
  };

  componentDidUpdate(prevProps) {
    const {
      actions,
      pageTranslations: { forms: { createPageTranslation: { fields } } },
      users: { currentUser }
    } = this.props;
    const {
      pageTranslations: {
        forms: { createPageTranslation: { fields: prevFields } }
      },
      users: { currentUser: prevCurrentUser }
    } = prevProps;

    if (!prevCurrentUser && currentUser) {
      this.loadTemplates();
    }

    if (fields.get("name") !== prevFields.get("name")) {
      actions.setFormField(
        "pageTranslations",
        "createPageTranslation",
        "slug",
        this.generateSlug(fields.get("name"))
      );
    }
  }

  generateSlug = name => {
    name = name.replace(/^\s+|\s+$/g, ""); // trim
    name = name.toLowerCase();

    const from = "àáäâąæãåāèéëêęėēìíïîòóöôóõœøōùúüûñçćčśßšłżźžń·/_,:;";
    const to = "aaaaaaaaaeeeeeeeiiiiooooooooouuuuncccssslzzzn------";
    for (var i = 0, l = from.length; i < l; i++) {
      name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    name = name
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    return name;
  };

  openAddPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsAddPageTranslationModalVisible(true);
  };

  closeAddPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsAddPageTranslationModalVisible(false);
  };

  prepareNewPageTranslation = slugIndex => {
    const {
      params: { slug },
      pagesLists: { pagesLists: { entities: pagesLists } },
      pageTranslations: { forms: { createPageTranslation: { fields } } },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const data = {
      locale: defaultLocale,
      name: fields.get("name"),
      templateUID: fields.get("templateUID"),
      slug:
        slugIndex !== 0
          ? `${fields.get("slug")}-${slugIndex}`
          : fields.get("slug"),
      sort: fields.get("sort")
    };
    return data;
  };

  createPageTranslation = slugIndex => {
    const { notificationSystem, actions } = this.props;
    slugIndex = typeof slugIndex === "number" ? slugIndex : 0;
    actions
      .createPagesTranslation(this.prepareNewPageTranslation(slugIndex))
      .then(({ error, payload }) => {
        if (error) {
          if (payload.errors.slug) {
            this.createPageTranslation(slugIndex + 1);
          }
          addNotificationsForInvalidFields(payload, notificationSystem);
          return false;
        } else {
          return true;
        }
      });
    actions.setIsAddPageTranslationModalVisible(false);
  };

  onTemplateSelect = value => {
    const { actions } = this.props;
    actions.setFormField(
      "pageTranslations",
      "createPageTranslation",
      "templateUID",
      value
    );
  };

  render() {
    const {
      actions,
      pages,
      msg: { pageTranslations: msg },
      templates: { templates: { entities: templates } },
      pageTranslations,
      pageTranslations: { forms },
      history,
      notificationSystem,
      locales: { locales: { defaultLocale } },
      users: { currentUser }
    } = this.props;

    const createPageTranslationFormProps = {
      feature: "pageTranslations",
      actions: actions,
      form: forms.createPageTranslation,
      formName: "createPageTranslation",
      msg: msg.forms.createPageTranslation,
      validateFormField: actions.validateFormFieldPagesTranslations
    };

    let templateSelectOptions = [];
    templates.forEach(function(item, index) {
      templateSelectOptions.push({
        value: item.get("uid"),
        label: item.get("name")
      });
    });

    let isAdmin = false;
    currentUser &&
      currentUser.get("groups").forEach(function(group) {
        if (group.name === "admin") {
          isAdmin = true;
        }
      });

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">Kategorie</h2>
          <div className="col-xs-4">
            {isAdmin && (
              <button
                className="info"
                onClick={this.openAddPageTranslationModal}
              >
                dodaj stronę
              </button>
            )}
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Strony</div>
              <div className="content-wrapper">
                <Table
                  defaultLocale={defaultLocale}
                  history={history}
                  pages={pages}
                  pageTranslations={pageTranslations}
                  tableWidth={1000}
                  tableHeight={300}
                  actions={actions}
                  notificationSystem={notificationSystem}
                />
              </div>
            </div>
          </div>
        </div>
        {forms.createPageTranslation.isAddModalVisible && (
          <Modal
            closeModalAction={this.closeAddPageTranslationModal}
            enterAction={this.createPageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Utwórz nowy wpis:</h3>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Nazwa"
                  field="name"
                  {...createPageTranslationFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="slug"
                  field="slug"
                  {...createPageTranslationFormProps}
                />
              </div>
              <div className="col-xs-12">
                <Select
                  name="select-template"
                  value={forms.createPageTranslation.fields.templateUID}
                  options={templateSelectOptions}
                  onChange={this.onTemplateSelect}
                  clearable={false}
                />
              </div>
              <button className="error" onClick={this.createPageTranslation}>
                Tak
              </button>
              <button
                className="info"
                onClick={this.closeAddPageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pages/pages.react.js